<div class="action-gallery">
  <!-- Header -->
  <div class="gallery-header">
    <h2>Action Gallery</h2>

    <div class="header-controls">
      <!-- Organization Selector -->
      <div class="org-selector">
        <label for="orgSelect">Organization:</label>
        <select
          id="orgSelect"
          [ngModel]="selectedOrganization?.ID"
          (ngModelChange)="onOrganizationChange($event)"
        >
          <option *ngFor="let org of organizations" [value]="org.ID">
            {{ org.Name }}
          </option>
        </select>
        <span *ngIf="selectedOrganization" class="plan-badge" [ngClass]="getPlanBadgeClass(organizationPlanLevel)">
          {{ organizationPlanLevel === 0 ? 'Free' : 'Level ' + organizationPlanLevel }}
        </span>
      </div>

      <!-- Search -->
      <div class="search-box">
        <input
          type="text"
          placeholder="Search actions..."
          [(ngModel)]="searchTerm"
          (ngModelChange)="onSearchChange()"
        />
      </div>

      <!-- Show Unavailable Toggle -->
      <label class="toggle-label">
        <input type="checkbox" [(ngModel)]="showUnavailable" />
        Show unavailable
      </label>
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="isLoading" class="loading-state">
    Loading actions...
  </div>

  <!-- Error Message -->
  <div *ngIf="errorMessage" class="error-message">
    {{ errorMessage }}
  </div>

  <!-- Success Message -->
  <div *ngIf="successMessage" class="success-message">
    {{ successMessage }}
  </div>

  <!-- Main Content -->
  <div *ngIf="!isLoading" class="gallery-content">
    <!-- Category Sidebar -->
    <div class="category-sidebar">
      <h3>Categories</h3>

      <div class="category-list">
        <!-- All Actions -->
        <div
          class="category-item"
          [class.selected]="!selectedCategory"
          (click)="selectCategory(null)"
        >
          <span class="category-name">All Actions</span>
          <span class="category-count">{{ actionCards.length }}</span>
        </div>

        <!-- Category Tree -->
        <ng-container *ngFor="let node of categoryTree">
          <ng-container *ngTemplateOutlet="categoryNodeTemplate; context: { node: node, level: 0 }"></ng-container>
        </ng-container>
      </div>
    </div>

    <!-- Action Cards Grid -->
    <div class="action-grid">
      <div *ngIf="filteredActionCards.length === 0" class="no-results">
        No actions found matching your criteria.
      </div>

      <div *ngFor="let card of filteredActionCards" class="action-card" [class.unavailable]="!card.isAvailable" [class.configured]="card.isConfigured">
        <!-- Card Header -->
        <div class="card-header">
          <div class="action-icon">
            <i [class]="card.izzyAction.IconClass || 'fa-solid fa-cog'"></i>
            <i *ngIf="card.izzyAction.RequiresCredentials" class="fa-solid fa-key credential-indicator" title="Requires credentials"></i>
          </div>
          <div class="action-info">
            <h4 class="action-name">{{ card.izzyAction.Name }}</h4>
            <span class="category-label" *ngIf="card.category">{{ card.category.Name }}</span>
          </div>
        </div>

        <!-- Card Body -->
        <div class="card-body">
          <p class="action-description">{{ card.izzyAction.Description || 'No description available.' }}</p>
        </div>

        <!-- Card Footer -->
        <div class="card-footer">
          <div class="badges">
            <span class="plan-badge" [ngClass]="getPlanBadgeClass(card.planLevel)">
              {{ card.planName }}
            </span>
            <span *ngIf="card.isPrivate" class="private-badge">Private</span>
            <span *ngIf="card.isConfigured" class="configured-badge">Configured</span>
          </div>

          <div class="card-actions">
            <button
              *ngIf="!card.isConfigured && card.isAvailable"
              class="btn btn-primary btn-sm"
              (click)="addToOrganization(card)"
              [disabled]="!selectedOrganization"
            >
              Add
            </button>
            <button
              *ngIf="card.isConfigured && card.isAvailable"
              class="btn btn-added btn-sm"
              disabled
              title="Already added to this organization"
            >
              <i class="fa-solid fa-check"></i> Added
            </button>
            <button
              *ngIf="!card.isAvailable"
              class="btn btn-disabled btn-sm"
              disabled
              title="Upgrade your plan to access this action"
            >
              Upgrade
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Category Node Template (recursive) -->
<ng-template #categoryNodeTemplate let-node="node" let-level="level">
  <div
    class="category-item"
    [class.selected]="selectedCategory?.ID === node.category.ID"
    [style.paddingLeft.px]="16 + (level * 16)"
    (click)="selectCategory(node.category)"
  >
    <span
      *ngIf="node.children.length > 0"
      class="expand-icon"
      (click)="toggleCategory(node); $event.stopPropagation()"
    >
      {{ node.isExpanded ? '&#9660;' : '&#9654;' }}
    </span>
    <span class="category-name">{{ node.category.Name }}</span>
    <span class="category-count">{{ getCategoryActionCount(node) }}</span>
  </div>

  <ng-container *ngIf="node.isExpanded">
    <ng-container *ngFor="let child of node.children">
      <ng-container *ngTemplateOutlet="categoryNodeTemplate; context: { node: child, level: level + 1 }"></ng-container>
    </ng-container>
  </ng-container>
</ng-template>
